import { render, staticRenderFns } from "./SearchTopBar.vue?vue&type=template&id=22a75dee&scoped=true&"
import script from "./SearchTopBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchTopBar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SearchTopBar.vue?vue&type=style&index=0&id=22a75dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a75dee",
  null
  
)

export default component.exports